import type React from 'react';

export interface ChainPositionBadgeProps {
  position: number;
  total: number;
}

export function ChainPositionBadge({
  position,
  total,
}: ChainPositionBadgeProps): React.JSX.Element | null {
  if (!position) return null;
  const isReincidence = position > 1;
  const critical = position >= 3;
  return (
    <span
      className={`chain-pos${critical ? ' chain-pos--critical' : isReincidence ? ' chain-pos--warn' : ''}`}
    >
      {position}/{total}
      {critical && ' · reincidência crítica'}
    </span>
  );
}
